import { useEffect, useRef, useState } from 'react';

import { NavLink, useNavigate } from 'react-router-dom';

import {
  Avatar,
  Box,
  Button,
  Divider,
  Hidden,
  lighten,
  List,
  ListItem,
  ListItemText,
  Popover,
  Typography
} from '@mui/material';
import { getProfile } from 'src/redux/authSlice';
import { styled } from '@mui/material/styles';
import ExpandMoreTwoToneIcon from '@mui/icons-material/ExpandMoreTwoTone';
import LockOpenTwoToneIcon from '@mui/icons-material/LockOpenTwoTone';
import AccountTreeTwoToneIcon from '@mui/icons-material/AccountTreeTwoTone';

import { useDispatch, useSelector } from 'react-redux';
import { logout } from 'src/redux/authSlice';
import { useTranslation } from 'react-i18next';

const UserBoxButton = styled(Button)(
  ({ theme }) => `
        padding-left: ${theme.spacing(1)};
        padding-right: ${theme.spacing(1)};
`
);

const MenuUserBox = styled(Box)(
  ({ theme }) => `
        background: ${theme.colors.alpha.black[5]};
        padding: ${theme.spacing(2)};
`
);

const UserBoxText = styled(Box)(
  ({ theme }) => `
        text-align: left;
        padding-left: ${theme.spacing(1)};
`
);

const UserBoxLabel = styled(Typography)(
  ({ theme }) => `
        font-weight: ${theme.typography.fontWeightBold};
        color: ${theme.palette.secondary.main};
        display: block;
`
);

const UserBoxDescription = styled(Typography)(
  ({ theme }) => `
        color: ${lighten(theme.palette.secondary.main, 0.5)}
`
);

function HeaderUserbox() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authUser = useSelector((x) => x.user);
  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };
 
  const user = {
    name: (authUser?.profile?.firstname && authUser?.profile?.lastname) ?
      `${authUser.profile.firstname} ${authUser.profile.lastname}` :
      authUser?.profile?.email || '',
    avatar: authUser?.profile?.picture
      ? `${process.env.REACT_APP_API_BASE_URL}/user/profilepic/${authUser.profile.picture}`
      : undefined,
    // userKind n'est que le type technique du modèle (un assistant partage celui du
    // super admin, d'où "SuperAdmin" affiché à tort) : on se base sur account_type.
    jobtitle:
      authUser?.profile?.account_type === 'SUPER_ADMIN_ASSISTANT'
        ? t('activityLog.assistant')
        : authUser?.profile?.account_type === 'SUPER_ADMIN'
          ? t('activityLog.superAdmin')
          : authUser?.profile?.userKind || '',
  };

  const ref = useRef(null);
  const [isOpen, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  useEffect(()=>{
    dispatch(getProfile());
  },[])

  return (
    <>
      <UserBoxButton color="secondary" ref={ref} onClick={handleOpen}>
        <Avatar variant="rounded" alt={user.name} src={user.avatar} />
        <Hidden mdDown>
          <UserBoxText>
            <UserBoxLabel variant="body1" style={{color:"white"}}>{user.name}</UserBoxLabel>
            <UserBoxDescription variant="body2" style={{color:"white"}}>{user.jobtitle}</UserBoxDescription>
          </UserBoxText>
        </Hidden>
        <Hidden smDown>
          <ExpandMoreTwoToneIcon sx={{ ml: 1 }} />
        </Hidden>
      </UserBoxButton>
      <Popover
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <MenuUserBox sx={{ minWidth: 210 }} display="flex">
          <Avatar variant="rounded" alt={user.name} src={user.avatar} />
          <UserBoxText>
            <UserBoxLabel variant="body1" style={{color:"white"}}>{user.name}</UserBoxLabel>
            
          </UserBoxText>
        </MenuUserBox>
        <Divider sx={{ mb: 0 }} />
        <List sx={{ p: 1 }} component="nav">
          <ListItem
            button
            to="/management/profile/settings"
            component={NavLink} style={{color:"white"}}
          >
            <AccountTreeTwoToneIcon fontSize="small" style={{color:"white"}}/>
            <ListItemText primary={t('header.accountSettings')} style={{color:"white"}}/>
          </ListItem>
        </List>
        <Divider />
        <Box sx={{ m: 1 }}>
          <Button color="primary" fullWidth
          onClick={handleLogout}>
            <LockOpenTwoToneIcon sx={{ mr: 1 }} />
            {t('header.signOut')}
          </Button>
        </Box>
      </Popover>
    </>
  );
}

export default HeaderUserbox;
